import { render, staticRenderFns } from "./TournamentsMain.vue?vue&type=template&id=2aa3bf39&scoped=true"
import script from "./TournamentsMain.vue?vue&type=script&lang=js"
export * from "./TournamentsMain.vue?vue&type=script&lang=js"
import style0 from "./TournamentsMain.vue?vue&type=style&index=0&id=2aa3bf39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3bf39",
  null
  
)

export default component.exports